import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IUserList } from '../models/response/getUserListResponseModel'

export class GetUserByIdApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/user/getById/',
      requesterInfo,
    })
  }

  public async getUserById(userId): Promise<IUserList> {
    this.props.url = `${this.props.url}${userId}`
    return await this.getAsync<IUserList>()
  }
}
